var map = {
	"./music-instructions.json": 5485,
	"./music-library-intro2024.json": 5486,
	"./music-library-launch2024.json": 5487,
	"./music-progression.json": 5488,
	"./startSourcesAdvanced.json": 5489,
	"./startSourcesSimple.json": 5490,
	"./startSourcesSimple2.json": 5491,
	"./startSourcesTracks.json": 5492
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5047;